import type { IDropdownOptions } from '@/Interfaces/Data';
import { UFs } from '@/static/Ufs';

const useUf = () => {
  function getUfInfo(initials: string) {
    const uf = UFs.find(uf => uf.sigla === initials);

    return uf;
  }

  const ufOptions: IDropdownOptions<string, string>[] = UFs.map(uf => ({
    key: uf.sigla,
    text: uf.nome,
    value: uf.sigla,
  }));

  return {
    UFs,
    getUfInfo,
    ufOptions,
  };
};

export default useUf;
